class DevicesWidget extends Widget {
    constructor() {
        super(".qc-widget.devices");
        this.filters = JSON.parse(this.element.dataset.filters);
        this.selected = {
            filter: this.filters.mostviewed
        };
        this.defaults = {
            // label: this.element.querySelector('.current-label span').textContent
        };
        let sort = this.element.querySelector(".sort-by");
        let sort_btn = sort.querySelector(".current-label");
        // sort_btn.addEventListener("click", e => {
        //     sort.classList.toggle("active");
        // });
        let buttons = sort.querySelector("#sortable-by");
        let _that = this;
        buttons.addEventListener("change", e => {
            let filter = e.currentTarget.options[e.currentTarget.selectedIndex].value;
            console.log(filter);
            switch (filter) {
                case "mostviewed":
                    _that.filterMostViewed();
                    break;
                case "a-z":
                    _that.filterAlphabeticaly("a-z");
                    break;
                case "z-a":
                    _that.filterAlphabeticaly("z-a");
                    break;
            }

        });
    }
    reset() {
        this.element.querySelector("#sortable-by").selectedIndex = 0;
        this.filterMostViewed();
    }
    filterMostViewed() {
        let cards = document.querySelectorAll(".qc-widget.devices .card");
        let sortable = [];

        cards.forEach(elem => {
            sortable.push(elem);
        });
        sortable.sort((a, b) => {
            return a.dataset.order < b.dataset.order ? -1 : 1;
        });
        this.sortIt(sortable);
    }
    filterAlphabeticaly(sort) {
        let cards = document.querySelectorAll(".qc-widget.devices .card");
        let sortable = [];

        cards.forEach(elem => {
            sortable.push(elem);
        });

        if (sort == "a-z") {
            sortable.sort((a, b) => {
                return a.querySelector(".mdn-Card--default .mdn-Heading").textContent < b.querySelector(".mdn-Card--default .mdn-Heading").textContent ? -1 : 1;
            });
        }
        if (sort == "z-a") {
            sortable.sort((a, b) => {
                return a.querySelector(".mdn-Card--default .mdn-Heading").textContent > b.querySelector(".mdn-Card--default .mdn-Heading").textContent ? -1 : 1;
            });
        }
        this.sortIt(sortable);
    }
    sortIt(sortable) {
        let content = document.querySelector(".qc-widget.devices .content");
        let i = 0;
        sortable.forEach(elem => {
            i++;
            let t = (i * 30);
            elem.style.order = i;
            elem.classList.add("vanish");
            elem.style.transitionDelay = t + "ms";
            content.append(elem);
            setTimeout(() => {
                elem.classList.remove("vanish");
            }, 100);
        });
    }
}
window.addEventListener("eHelpFrameworkReady", e => {
    eHelpFramework.widgets.push(new DevicesWidget())
});